/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-syntax */
import { Middleware } from '@nuxt/types';

import parseParamsFromUrl from '~/composables/useParamsFromUrlService';

const getParamsFromUrl: Middleware = async ({ route, store }) => {
  if (JSON.stringify(route.query) !== JSON.stringify({})) {
    parseParamsFromUrl(route.query, store);
  }
};
export default getParamsFromUrl;
